import classNames from 'classnames'

type DownloadFileProps = {
  fileHeader?: string
  fileName?: string
  templateColumns?: string | any
  link?: string
  message: string
  className?: string
}

export default function DownloadFile({
  fileHeader,
  fileName,
  templateColumns,
  message,
  link,
  className = ``,
}: DownloadFileProps): React.ReactElement {
  let defaultClasses = `btn-link mb-4`

  const downloadTemplate: () => string = () => {
    if (link) {
      return encodeURI(link)
    }
    return encodeURI(`${fileHeader},${templateColumns}`)
  }
  return (
    <a href={downloadTemplate()} target="_blank" className={classNames(defaultClasses, className)} rel="noreferrer">
      {message}
    </a>
  )
}
